import { IIconProps } from '@cian/ui-kit-design-tokens/internal/types';
import * as React from 'react';

export const IconPause16 = ({ color }: IIconProps) => {
  const currentColor = color ? `var(--${color})` : 'currentColor';

  return (
    // oxlint-disable-next-line react/forbid-elements
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 2C9 1.44772 9.44772 1 10 1H12C12.5523 1 13 1.44772 13 2V14C13 14.5523 12.5523 15 12 15H10C9.44772 15 9 14.5523 9 14V2Z"
        fill={currentColor}
      />
      <path
        d="M3 2C3 1.44772 3.44772 1 4 1H6C6.55228 1 7 1.44772 7 2V14C7 14.5523 6.55228 15 6 15H4C3.44772 15 3 14.5523 3 14V2Z"
        fill={currentColor}
      />
    </svg>
  );
};
